import type { Location } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { levelsList } from '../Location.Mappings';
import { RadioButton } from '../../../utils/MatchingColumnsStyles';

export interface MatchLocationColumnsOptions {
  getSelectedLocationId?: () => string | null;
  onSelectLocationId?: (id: string) => void;
  isDefaultSelectedLocation?: (location: Location) => boolean;
}

export const createMatchLocationColumns = (
  options: MatchLocationColumnsOptions = {},
): ColumnProps<Location>[] => [
  {
    dataField: '__radio_selection' as any,
    caption: '',
    width: 54,
    visible: true,
    fixed: true,
    allowFiltering: false,
    allowSearch: false,
    allowSorting: false,
    alignment: 'center',
    cellRender: (e: any) => {
      const rowLocation = e.data as Location;
      const rowId = rowLocation?.id;

      if (!rowId) {
        return null;
      }

      const selectedLocationId = options.getSelectedLocationId?.();
      const isChecked = selectedLocationId
        ? selectedLocationId === rowId
        : !!options.isDefaultSelectedLocation?.(rowLocation);

      return (
        <RadioButton
          type="button"
          aria-label="Select location"
          aria-pressed={isChecked}
          $checked={isChecked}
          onClick={(event) => {
            event.stopPropagation();
            options.onSelectLocationId?.(rowId);
          }}
        />
      );
    },
  },
  {
    dataField: 'name',
    caption: 'Name',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'level',
    caption: 'Type',
    dataType: 'string',
    visible: true,
    lookup: {
      dataSource: levelsList,
      valueExpr: 'value',
      displayExpr: 'label',
    },
  },
  {
    dataField: 'parent.name',
    caption: 'Parent',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'address',
    caption: 'Address',
    dataType: 'string',
    visible: true,
  },
];

const matchLocationColumns = createMatchLocationColumns();

export default matchLocationColumns;
